import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Capacitor} from '@capacitor/core';

import Fetcher from '../../../components/common/Fetcher';
import styles from './styles.module.scss';
import useLogger, {Action} from '../../../hooks/useLogger';
import {getQuickMenus} from '../../../services/brands';

export default function QuickMenu() {
  interface QuickMenu {
    id: number;
    image: string;
    type: string;
    content: string;
    isActive: boolean;
    priority: number;
    link: string;
    isInternal: boolean;
  }
  const navigator = useNavigate();
  const sender = useLogger();
  const getQuickMenu = async () => {
    const res = await getQuickMenus();
    return res.data;
  };

  const [quickMenu, setQuickMenu] = useState<QuickMenu[]>();

  const init = async () => {
    const list = await getQuickMenu();
    list.sort(
      (pre: QuickMenu, next: QuickMenu) => pre.priority - next.priority,
    );
    setQuickMenu(list);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <Fetcher fetcher={getQuickMenu} setter={setQuickMenu}>
      <div
        className={`${styles.quick_menu} ${
          Capacitor.getPlatform() === 'android'
            ? styles.android
            : Capacitor.getPlatform() === 'ios'
            ? styles.ios
            : ''
        }`}>
        {quickMenu?.map((item, index) => (
          <button
            key={index}
            className={styles.menu_button}
            onClick={() => {
              sender({
                _msg: 'quickMenu_' + (index + 1),
                _screen: window.location.pathname,
                _action: Action.CLICK,
              });
              navigator(item.link);
            }}>
            <div className={styles.imgArea}>
              <img
                src={item.image}
                alt={`${item.content} image`}
                width={40}
                height={40}
              />
            </div>
            <span className={styles.txt}>{item.content}</span>
          </button>
        ))}
      </div>
    </Fetcher>
  );
}
